import { cva } from 'class-variance-authority';

export const thumbnailVariants = cva('border', {
  variants: {
    variant: {
      default: 'rounded-full object-cover',
      contain: 'rounded-lg object-contain',
    },
    size: {
      default: 'size-8',
      xs: 'size-8',
      sm: 'size-12',
      md: 'size-16',
      lg: 'size-32',
      xl: 'size-48',
      xxl: 'size-64',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
});
